import Card from "@components/Card";
import { getIndicatorColor } from "@utils/colorCalculations";
import { roundValue } from "@utils/formatNumber";
import { metricPresentation, metricReasonStyle } from "@utils/metricPresentation";

const IndicatorCard = ({ title, indicator, envelope, black, tooltip, reasonId }) => {
  const hasLegacyIndicator = typeof indicator === "number" && Number.isFinite(indicator);
  const effectiveEnvelope = envelope ?? {
    id: "indicator",
    value: hasLegacyIndicator ? indicator : null,
    unit: "ratio",
    status: hasLegacyIndicator ? "ok" : "source_unavailable",
  };
  const fallbackReasonId = !envelope && !hasLegacyIndicator
    ? `metric-indicator-${String(title).toLowerCase().replace(/[^a-z0-9]+/g, "-")}-reason`
    : undefined;
  const presented = metricPresentation(effectiveEnvelope, {
    formatter: roundValue,
    reasonId: reasonId ?? fallbackReasonId,
  });
  const effectiveIndicator = presented.value;
  const color = getIndicatorColor(effectiveIndicator)
  const hasValue = presented.available;

  return (
    <>
      <Card
        label={title}
        content={<span aria-describedby={presented.describedBy}>{presented.text}</span>}
        color={black || !hasValue ? 'black' : color}
        tooltip={tooltip}
      />
      {!presented.available && (
        <span id={presented.describedBy} style={metricReasonStyle}>{presented.reason}</span>
      )}
    </>
    // <div className="card">
    //   <span className="card-title">{title}</span>
    //   <span className={`card-value large color-${black ? 'black' : color}`}>{roundValue(indicator ?? 0)}</span>
    //   {/* <span className={`card-value large`}>{roundValue(indicator)}</span> */}
    // </div>
  )
}

export default IndicatorCard;
